import { COMMON_LABELS } from "../default-constants";

import {
  Select,
  Input,
  Box,
  FormField,
  SpaceBetween,
  Form,
  Container,
  ColumnLayout,
  Textarea,
  DatePicker,
  Tiles,
  Badge,
} from "@cloudscape-design/components-themed";
import { LABELS, PLACE_HOLDERS, INPUT_LABELS } from "./constants";
import { formatYearDate } from "../../utils/format";

/*===================================================================================
 * 料率調整案件の調整内容入力フォーム
 * 概要：調整内容入力フォームを実装
 *
 * 前の画面からの必要なパラメーター
 * なし
 *
 * 遷移先：なし
 * 戻り先：なし
 ===================================================================================*/
//未実装：ドロップダウン、各入力チェック
export const AdjustmentForm = (props: any) => {
  return (
    <Form>
      <Container>
        <SpaceBetween size="l">
          {!props.isRegister && (
            <Box float="right">
              <Badge color="green">
                {LABELS.LAST_UPDATER}
                {props.updateBy}/{LABELS.LAST_UPDATING_TIME}
                {formatYearDate(props.updateAt)}
              </Badge>
            </Box>
          )}
          <FormField
            label={
              <SpaceBetween direction="horizontal" size="xs">
                <Box variant="strong">{LABELS.CONTRACT_ROUTE}</Box>
                <Box variant="small" color="text-status-error">
                  {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                </Box>
              </SpaceBetween>
            }
          >
            <Tiles
              items={props.contractRouteList}
              columns={2}
              onChange={(e: any) => {
                props.setContractRoute(e.detail.value);
                props.setIsFormEntered(true);
                props.setGwCompany("");
                props.setGwCompanyErrorMsg("");
                props.setInclusionMerchant("");
                props.setInclusionMerchantErrorMsg("");
                props.setDocomoDefinedIndustry("");
                props.setDocomoDefinedIndustryErrorMsg("");
                props.setAppliedIndustry("");
                props.setAppliedIndustryErrorMsg("");
              }}
              value={props.contractRoute}
            />
          </FormField>
          <ColumnLayout columns={3}>
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">{LABELS.GW_COMPANY}</Box>
                  <Box variant="small" color="text-status-error">
                    {INPUT_LABELS.GW_COMPANY_MESSAGE}
                  </Box>
                </SpaceBetween>
              }
              stretch={true}
              errorText={props.gwCompanyErrorMsg}
            >
              <Select
                disabled={props.contractRoute !== "1"}
                selectedOption={props.gwCompany}
                filteringType="auto"
                onChange={(e: any) => {
                  props.setGwCompany(e.detail.selectedOption);
                  props.setIsFormEntered(true);
                  props.checkRequired(
                    e.detail.selectedOption,
                    props.setGwCompanyErrorMsg
                  );
                }}
                options={props.gwListData}
                selectedAriaLabel="Selected"
              />
            </FormField>
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">{LABELS.INCLUSION_MERCHANT}</Box>
                  <Box variant="small" color="text-status-error">
                    {INPUT_LABELS.INCLUSION_MERCHANT_MESSAGE}
                  </Box>
                </SpaceBetween>
              }
              stretch={true}
              errorText={props.inclusionMerchantErrorMsg}
            >
              <Select
                disabled={props.contractRoute !== "2"}
                selectedOption={props.inclusionMerchant}
                onChange={(e: any) => {
                  props.setInclusionMerchant(e.detail.selectedOption);
                  props.setIsFormEntered(true);
                  props.checkRequired(
                    e.detail.selectedOption,
                    props.setInclusionMerchantErrorMsg
                  );
                }}
                options={props.inclusionMerchantListData}
                selectedAriaLabel="Selected"
                filteringType="auto"
              />
            </FormField>
          </ColumnLayout>
          <ColumnLayout columns={3}>
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">{LABELS.APPLICATION_DATE}</Box>
                  <Box variant="small" color="text-status-error">
                    {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                  </Box>
                </SpaceBetween>
              }
              stretch={true}
              errorText={props.applicationDateErrorMsg}
            >
              <DatePicker
                value={props.applicationDate}
                onChange={({ detail }) => {
                  props.setApplicationDate(detail.value);
                  props.setIsFormEntered(true);
                  props.checkRequired(
                    detail.value,
                    props.setApplicationDateErrorMsg
                  );
                }}
                openCalendarAriaLabel={(selectedDate) =>
                  "Choose certificate expiry date" +
                  (selectedDate ? `, selected date is ${selectedDate}` : "")
                }
                nextMonthAriaLabel="Next month"
                placeholder="YYYY/MM/DD"
                previousMonthAriaLabel="Previous month"
                todayAriaLabel="Today"
                readOnly={props.readOnly}
              />
            </FormField>
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">{LABELS.ANSWER_DATE}</Box>
                  <Box variant="small" color="text-status-error">
                    {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                  </Box>
                </SpaceBetween>
              }
              stretch={true}
              errorText={props.answerDateErrorMsg}
            >
              <DatePicker
                value={props.answerDate}
                onChange={({ detail }) => {
                  props.setAnswerDate(detail.value);
                  props.setIsFormEntered(true);
                  props.checkRequired(
                    detail.value,
                    props.setAnswerDateErrorMsg
                  );
                }}
                openCalendarAriaLabel={(selectedDate) =>
                  "Choose certificate expiry date" +
                  (selectedDate ? `, selected date is ${selectedDate}` : "")
                }
                nextMonthAriaLabel="Next month"
                placeholder="YYYY/MM/DD"
                previousMonthAriaLabel="Previous month"
                todayAriaLabel="Today"
                readOnly={props.readOnly}
              />
            </FormField>
          </ColumnLayout>
          <ColumnLayout columns={3}>
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">{LABELS.ANSWER_RATE}</Box>
                  <Box variant="small" color="text-status-error">
                    {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                  </Box>
                </SpaceBetween>
              }
              stretch={true}
              errorText={props.answerRateErrorMsg}
              constraintText="整数部分2桁,小数点以下2桁まで"
            >
              <Input
                value={props.answerRate}
                onChange={(e) => {
                  props.setAnswerRate(e.detail.value);
                  props.setIsFormEntered(true);
                  props.checkAnswerRate(
                    e.detail.value,
                    props.setAnswerRateErrorMsg
                  );
                }}
                placeholder={PLACE_HOLDERS.RATE}
              />
            </FormField>
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">{LABELS.DESIRED_RATE}</Box>
                  <Box variant="small" color="text-status-error">
                    {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                  </Box>
                </SpaceBetween>
              }
              stretch={true}
              errorText={props.desiredRateErrorMsg}
              constraintText="100文字以内"
            >
              <Input
                value={props.desiredRate}
                onChange={(e) => {
                  props.setDesiredRate(e.detail.value);
                  props.setIsFormEntered(true);
                  props.checkDesiredRate(
                    e.detail.value,
                    props.setDesiredRateErrorMsg
                  );
                }}
              />
            </FormField>
          </ColumnLayout>
          <ColumnLayout columns={3}>
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">{LABELS.SALES}</Box>
                  <Box variant="small" color="text-status-error">
                    {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                  </Box>
                </SpaceBetween>
              }
              stretch={true}
              errorText={props.salesErrorMsg}
              constraintText="半角数字10桁以内"
            >
              <Input
                value={props.sales}
                onChange={(e) => {
                  props.setSales(e.detail.value);
                  props.setIsFormEntered(true);
                  props.checkSales(e.detail.value, props.setSalesErrorMsg);
                }}
              />
            </FormField>
          </ColumnLayout>
          <ColumnLayout columns={3}>
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">{LABELS.ALL_STORE_NUMBER}</Box>
                </SpaceBetween>
              }
              stretch={true}
              errorText={props.allStoreNumberErrorMsg}
              constraintText="半角数字5桁以内"
            >
              <Input
                value={props.allStoreNumber}
                onChange={(e) => {
                  props.setAllStoreNumber(e.detail.value);
                  props.setIsFormEntered(true);
                  props.checkStoreNumber(
                    e.detail.value,
                    props.setAllStoreNumberErrorMsg,
                    false
                  );
                }}
              />
            </FormField>
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">{LABELS.INSTALLED_SHOP_NUMBER}</Box>
                  <Box variant="small" color="text-status-error">
                    {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                  </Box>
                </SpaceBetween>
              }
              stretch={true}
              errorText={props.storeNumberErrorMsg}
              constraintText="半角数字5桁以内"
            >
              <Input
                value={props.storeNumber}
                onChange={(e) => {
                  props.setStoreNumber(e.detail.value);
                  props.setIsFormEntered(true);
                  props.checkStoreNumber(
                    e.detail.value,
                    props.setStoreNumberErrorMsg,
                    true
                  );
                }}
              />
            </FormField>
          </ColumnLayout>
          <ColumnLayout columns={3}>
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">{LABELS.DOCOMO_DEFINED_INDUSTRY}</Box>
                  <Box variant="small" color="text-status-error">
                    {INPUT_LABELS.DOCOMO_DEFINED_INDUSTRY_MESSAGE}
                  </Box>
                </SpaceBetween>
              }
              errorText={props.docomoDefinedIndustryErrorMsg}
              stretch={true}
            >
              <Select
                disabled={props.contractRoute !== "1"}
                selectedOption={props.docomoDefinedIndustry}
                filteringType="auto"
                onChange={(e: any) => {
                  props.setDocomoDefinedIndustry(e.detail.selectedOption);
                  props.setIsFormEntered(true);
                  props.checkRequired(
                    e.detail.selectedOption,
                    props.setDocomoDefinedIndustryErrorMsg
                  );
                }}
                options={props.docomoDefinedIndustryList}
              />
            </FormField>
            <FormField
              label={LABELS.APPLIED_INDUSTRY}
              stretch={true}
              errorText={props.appliedIndustryErrorMsg}
              constraintText="100文字以内"
            >
              <Input
                disabled={props.contractRoute !== "2"}
                value={props.appliedIndustry}
                onChange={(e) => {
                  props.setAppliedIndustry(e.detail.value);
                  props.setIsFormEntered(true);
                  props.checkLengthHundred(
                    e.detail.value,
                    props.setAppliedIndustryErrorMsg
                  );
                }}
              />
            </FormField>
          </ColumnLayout>
          <ColumnLayout columns={3}>
            <FormField
              label={LABELS.HANDLING_PRODUCTS}
              stretch={true}
              errorText={props.handlingProductsErrorMsg}
              constraintText="100文字以内"
            >
              <Input
                // 加盟店のサービス名がネット以外の場合非活性
                disabled={props.serviceName !== "2"}
                value={props.handlingProducts}
                onChange={(e) => {
                  props.setHandlingProducts(e.detail.value);
                  props.setIsFormEntered(true);
                  props.checkLengthHundred(
                    e.detail.value,
                    props.setHandlingProductsErrorMsg
                  );
                }}
              />
            </FormField>
            <FormField
              label={LABELS.RATE_CRITERIA}
              stretch={true}
              errorText={props.rateCriteriaErrorMsg}
              constraintText="100文字以内"
            >
              <Input
                value={props.rateCriteria}
                onChange={(e) => {
                  props.setRateCriteria(e.detail.value);
                  props.setIsFormEntered(true);
                  props.checkLengthHundred(
                    e.detail.value,
                    props.setRateCriteriaErrorMsg
                  );
                }}
              />
            </FormField>
          </ColumnLayout>
          <FormField
            label={
              <SpaceBetween direction="horizontal" size="xs">
                <Box variant="strong">{LABELS.COST}</Box>
                <Box variant="small" color="text-status-error">
                  {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                </Box>
              </SpaceBetween>
            }
            stretch={true}
            errorText={props.costErrorMsg}
          >
            <Tiles
              items={props.costList}
              columns={3}
              onChange={(e: any) => {
                props.setCost(e.detail.value);
                props.setIsFormEntered(true);
                props.setCostAdjustInfo("");
                props.setCostAdjustInfoErrorMsg("");
              }}
              value={props.cost}
            />
          </FormField>
          <ColumnLayout columns={3}>
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">{LABELS.COST_ADJUSTMENT_INFO}</Box>
                  <Box variant="small" color="text-status-error">
                    {INPUT_LABELS.COST_ADJUSTMENT_INFO_MESSAGE}
                  </Box>
                </SpaceBetween>
              }
              stretch={true}
              errorText={props.costAdjustInfoErrorMsg}
              constraintText="50文字以内"
            >
              <Input
                disabled={props.cost !== true}
                value={props.costAdjustInfo}
                onChange={(e) => {
                  props.setCostAdjustInfo(e.detail.value);
                  props.setIsFormEntered(true);
                  props.checkCostAdjustInfo(
                    e.detail.value,
                    props.setCostAdjustInfoErrorMsg
                  );
                }}
              />
            </FormField>
          </ColumnLayout>

          <FormField
            label={LABELS.REMARK}
            stretch={true}
            errorText={props.remarkErrorMsg}
            constraintText="400文字以内"
          >
            <Textarea
              value={props.remark}
              onChange={({ detail }) => {
                props.setRemark(detail.value);
                props.setIsFormEntered(true);
                props.checkRemark(detail.value, props.setRemarkErrorMsg);
              }}
            />
          </FormField>
        </SpaceBetween>
      </Container>
    </Form>
  );
};
